import React from 'react';
import LegalPage from './LegalPage';

const Disclaimer: React.FC = () => <LegalPage documentId="disclaimer" />;

export default Disclaimer;
